export default "__VITE_ASSET__DwD7oeXw__"